import { createFileRoute } from '@tanstack/react-router';
import { MerchantDescriptorPatternsPage } from './MerchantDescriptorPatternsPage';
import { z } from 'zod';

const searchSchema = z.object({
  query: z.string().optional(),
  patternId: z.string().optional(),
  patternsPage: z.coerce.number().positive().int().optional().default(1),
  patternsPageSize: z.coerce.number().positive().int().optional().default(25),
  transactionsPage: z.coerce.number().positive().int().optional().default(1),
  transactionsPageSize: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/merchant-descriptor-patterns/',
)({
  component: MerchantDescriptorPatternsPage,
  validateSearch: searchSchema,
});
